import * as ApiManager from './_manager';
import store from '../store';

export const wishlist = {
  list: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/avail/link/${store.getters['availLink/getUuid']}/wishlist/get`,
      payload
    );
  },

  add: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/avail/link/${store.getters['availLink/getUuid']}/wishlist/add`,
      payload
    );
  },

  remove: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/avail/link/${store.getters['availLink/getUuid']}/wishlist/remove`,
      payload
    );
  },

  submit: () => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/avail/link/${store.getters['availLink/getUuid']}/wishlist/submit`
    );
  },
};
  